/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import { useDispatch, useSelector } from "react-redux";
import Header from "../../../components/common/layout/Header";
import React, { useEffect, useState } from "react";
import { url } from "../../../shared/utils/url";
import useAxios from "../../../shared/hooks/use-axios";
import { useTranslation } from "react-i18next";
import { Helmet } from "react-helmet";
import Canonical from "../../../components/common/layout/Canonical";
import { AddSvg, Next, Prev, StoreHoursSvg, StoreLocationSvg, TableSearch } from "../../../components/common/svg/AllSvg";
import { Link, useNavigate, useParams } from "react-router-dom";
import { sitemap } from "../../../shared/utils/sitemap";
import moment from "moment";
import EmptyList from "../../../components/common/form/EmptyList";
import NoSearch from "../../../components/common/form/NoSearch";
import Error from "../../../components/common/form/Error";
import { dataActions } from "../../../shared/store/data-Slice";

const Products = () => {
    const lang: string = useSelector((state: any) => state.ui.lang);
    const [storeData, setStoreData] = useState<any>(null)
    const [storeLoading, setStoreLoading] = useState<boolean>(true)
    const [category, setCategory] = useState<any>(null)
    const [categoryLoading, setCategoryLoading] = useState<boolean>(true)
    const [data, setData] = useState<any>(null)
    const [loading, setLoading] = useState<boolean>(true)
    const [isError, setIsError] = useState<boolean>(false)
    const [search, setSearch] = useState<string>("")
    const [debouncedValue, setDebouncedValue] = useState<string>(search);
    const [focus, setFocus] = useState<boolean>(false);
    const [lArr, setLArr] = useState<string>('none');
    const [rArr, setRArr] = useState<string>('block');
    const [select, setSelect] = useState<any>(null);
    const [animation, setAnimation] = useState<boolean>(false)
    const loaderData: any[] = [1, 2, 3, 4, 5]
    const { t } = useTranslation('common');
    const params = useParams();
    const navigate = useNavigate();
    const dispatch = useDispatch();

    useEffect(() => {
        const timer = setTimeout(() => {
            setDebouncedValue(search);
        }, 500);

        return () => clearTimeout(timer);
    }, [search]);

    const getStore = async () => {
        try {
            setStoreLoading(true)
            const res: any = await useAxios.get(`/${(!!lang ? lang : "en") + url?.store_details}${params?.code}/`);

            if (res && res?.status === 200) {
                setStoreData(res?.data?.[0])
                setStoreLoading(false);
                sitemap();
            }
        } catch (error: any) {
            setStoreData(null);
            if (error?.response?.status === 404) {
                (!!params?.lang ? navigate(`/${params?.lang}/404`) : navigate("/404"))
            }
            setStoreLoading(false)
            console.error("error while feching store data", error);
        }
    };

    const getProductCategory = async () => {
        try {
            setCategoryLoading(true)
            const res: any = await useAxios.get(`/${(!!lang ? lang : "en") + url?.product_category}${params?.code}/`);

            if (res && res?.status === 200) {
                setCategory(res?.data)
                setCategoryLoading(false);
                setSelect(res?.data?.[0])
            }
        } catch (error) {
            setIsError(true)
            console.error("error while feching category data", error);
        }
    };

    const getProducts = async () => {
        try {
            setLoading(true)
            setIsError(false)
            const res: any = await useAxios.get(`/${(!!lang ? lang : "en") + url?.store_products}${!!debouncedValue ? `?search=${debouncedValue}` : ""}`);

            if (res && res?.status === 200) {
                let obj: any = {};

                for (let i = 0; i < category.length; i++) {
                    const el = category[i];
                    if (!obj.hasOwnProperty(el?.name)) {
                        obj[el?.name] = el?.name
                    }
                }

                const groupWiseProducts = Object.values(obj).map((category: any) => ({
                    category,
                    products: res?.data.filter((el: any) => el?.category?.name === category)
                }))
                setData(groupWiseProducts)
                setLoading(false);
            }
        } catch (error) {
            setIsError(true)
            setLoading(false)
            console.error("error while feching products data", error);
        }
    };

    useEffect(() => {
        (!!lang && !!params?.code) && getStore();
        (!!lang && !!params?.code) && getProductCategory();
    }, [lang, params?.code])

    useEffect(() => {
        (!!lang && category?.length > 0) && getProducts();
    }, [lang, debouncedValue, category])

    const handleScroll = (type: any) => {
        const scrollContainer: any = document.getElementById('scrollContainer');

        const updateArrows = () => {
            scrollContainer.scrollLeft > 0 ? setLArr('block') : setLArr('none');
            (scrollContainer.scrollWidth - scrollContainer.clientWidth) > scrollContainer.scrollLeft ? setRArr('block') : setRArr('none');
        }

        if (!!scrollContainer) {
            if (type === 'right') {
                scrollContainer.scrollLeft += 250;
                updateArrows()
            } else if (type === 'left') {
                scrollContainer.scrollLeft -= 250;
                updateArrows()
            }
        }
    }

    useEffect(() => {
        if (animation) {
            setTimeout(() => {
                setAnimation(false)
            }, 500)
        }
    }, [animation])

    function isStoreOpen(openingTime: string, closingTime: string) {
        const now = new Date();

        const baseDate = new Date();
        baseDate.setHours(0, 0, 0, 0);

        const [openHours, openMinutes, openSeconds] = openingTime.split(':').map(Number);
        const [closeHours, closeMinutes, closeSeconds] = closingTime.split(':').map(Number);

        const openingDate = new Date(baseDate);
        openingDate.setHours(openHours + 1, openMinutes, openSeconds, 0);

        const closingDate = new Date(baseDate);
        closingDate.setHours(closeHours + 1, closeMinutes, closeSeconds, 0);

        if (now >= openingDate && now <= closingDate) {
            if (lang === "en") {
                return `Open until ${moment(closingDate).format('hh:mm A')}`;
            } else if (lang === "hi") {
                return `रात ${moment(closingDate).format('hh:mm A')} तक खुला है`;
            } else {
                return `रात्री ${moment(closingDate).format('hh:mm A')} पर्यंत उघडे आहे`;
            }
        } else {
            if (lang === "en") {
                return `Opens at ${moment(openingDate).format('hh:mm A')}`;
            } else if (lang === "hi") {
                return `सुबह ${moment(openingDate).format('hh:mm A')} बजे खुलता है`;
            } else {
                return `सकाळी ${moment(openingDate).format('hh:mm A')} उघडते`;
            }
        }
    }

    const handleLink = (e: any, item: any) => {
        e.preventDefault();
        dispatch(dataActions.setWebOpen(true));
        dispatch(dataActions.setLink(item));
    }

    return (
        <>
            <Canonical />
            <Helmet>
                <title>{t("seo_friendly.products.title")}</title>
                <meta name="description" content={t("seo_friendly.products.desc")} />
            </Helmet>
            <div className="w-full h-full relative bg-white dark:bg-bgDarkDull">
                <div className="w-full products-bg shadow-[0px_15px_20px_0px_rgba(0,0,0,0.05)] dark:shadow-[0px_15px_20px_0px_#5454545e] rounded-b-[40px]">
                    <Header type="passenger" />

                    <div className="py-[30px] xlx:py-[40px] flex items-center msm:flex-row flex-col msm:justify-between w-full gap-[20px] msm:gap-[15px] container">
                        {/* store info */}
                        {storeLoading ?
                            <>
                                <div className="flex items-center gap-[15px] xlx:gap-[20px] animate-pulse">
                                    <div className="xlx:w-[110px] xlx:min-w-[110px] xlx:h-[110px] w-[80px] min-w-[80px] h-[80px] rounded-full bg-gray-200 dark:bg-gray-700"></div>
                                    <div className="flex flex-col gap-[4px]">
                                        <div className="w-[100px] h-[12px] bg-gray-200 rounded-full dark:bg-gray-700"></div>
                                        <div className="w-[180px] xs:w-[200px] h-[12px] bg-gray-200 rounded-full dark:bg-gray-700"></div>
                                    </div>
                                </div>

                                <div className="flex items-center gap-[15px] xlx:gap-[20px] xlsm:flex-row flex-col xs:w-auto w-full">
                                    <div className="flex flex-col gap-[5px] xlx:gap-[8px] xs:w-auto w-full">
                                        <div className="w-[100px] h-[12px] bg-gray-200 rounded-full dark:bg-gray-700"></div>
                                        <div className="w-full xs:w-[200px] xlx:w-[300px] h-[70px] bg-gray-200 rounded-[12px] dark:bg-gray-700"></div>
                                    </div>

                                    <div className="flex flex-col gap-[5px] xlx:gap-[8px] xs:w-auto w-full">
                                        <div className="w-[100px] h-[12px] bg-gray-200 rounded-full dark:bg-gray-700"></div>
                                        <div className="w-full xs:w-[200px] xlx:w-[300px] h-[70px] bg-gray-200 rounded-[12px] dark:bg-gray-700"></div>
                                    </div>
                                </div>
                            </>
                            :
                            <>
                                {!!storeData && <>
                                    <div className="flex items-center gap-[15px] xlx:gap-[20px]">
                                        <div className="xlx:w-[110px] xlx:min-w-[110px] xlx:h-[110px] w-[80px] min-w-[80px] h-[80px] rounded-full">
                                            <img src={storeData?.logo?.file} alt={storeData?.store_name} className="w-full h-full rounded-full" />
                                        </div>
                                        <div className="flex flex-col">
                                            <h2 className="text-primaryText dark:text-white font-bold">{storeData?.store_name}</h2>
                                            {/* <h6 className="text-black dark:text-white font-semibold flex xs:items-center xs:gap-[4px] xs:flex-row flex-col xs:whitespace-nowrap">
                                                <span className="flex items-center gap-[4px]">4.0
                                                    <div className="mt-[-4px]"><StarSvg /></div>
                                                    <span className="text-sm font-semibold text-[#5E5E5E] dark:text-textBlackDull">(8,000+)</span>
                                                </span>
                                                <span className="hidden xs:block">•</span>
                                                <span className="text-sm font-semibold text-[#4B4B4B] dark:text-textBlackDark">Fast food • Smoothies • Burgers</span>
                                            </h6> */}
                                            <h6 className="text-sm font-semibold text-[#4B4B4B] dark:text-textBlackDark">{storeData?.description}</h6>
                                        </div>
                                    </div>

                                    <div className="flex items-center gap-[15px] xlx:gap-[20px] xlsm:flex-row flex-col xs:w-auto w-full">
                                        <div className="flex flex-col gap-[5px] xlx:gap-[8px] xs:w-auto w-full">
                                            <p className="text-blackDull dark:text-textBlackDull font-semibold">{t("passenger.stores.store_location")}</p>
                                            <div style={{ background: "linear-gradient(93deg, #E7FDF9 6.73%, #F2FFFC 100.26%)" }} className="shadow-[0px_4px_6px_-4px_rgba(24,39,75,0.12),0px_8px_8px_-4px_rgba(24,39,75,0.08)] rounded-[12px] px-[18px] py-[15px] flex items-center gap-[15px] xs:w-auto w-full xlx:min-w-[300px]">
                                                <StoreLocationSvg />
                                                <div className="flex flex-col">
                                                    <h4 className="text-primaryText font-bold">{storeData?.station?.name}</h4>
                                                    <h6 className="line-clamp-1 font-semibold text-blackDull">{storeData?.location}</h6>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="flex flex-col gap-[5px] xlx:gap-[8px] xs:w-auto w-full">
                                            <p className="text-blackDull dark:text-textBlackDull font-semibold">{t("passenger.stores.hours")}</p>
                                            <div style={{ background: "linear-gradient(93deg, #E7FDF9 6.73%, #F2FFFC 100.26%)" }} className="shadow-[0px_4px_6px_-4px_rgba(24,39,75,0.12),0px_8px_8px_-4px_rgba(24,39,75,0.08)] rounded-[12px] px-[18px] py-[15px] flex items-center gap-[15px] xs:w-auto w-full xlx:min-w-[300px]">
                                                <StoreHoursSvg />
                                                <div className="flex flex-col">
                                                    <h4 className="text-primaryText font-bold capitalize">{storeData?.status !== "open" ? `${lang === "en" ? "Closed" : lang === "hi" ? "बंद" : "बंद"}` : `${lang === "en" ? "Open" : lang === "hi" ? "खुला" : "उघडा"}`}</h4>
                                                    <h6 className="font-semibold text-blackDull">{isStoreOpen(storeData?.opening_time, storeData?.closing_time)}</h6>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </>}
                            </>
                        }
                    </div>
                </div>

                <div className="w-full h-full container pb-[30px] xlx:pb-[60px] pt-[30px]" id="home">
                    <div className="flex flex-col gap-[20px] w-full">
                        {/* header & search */}
                        <div className="flex xsm:items-center w-full xsm:justify-between gap-[15px] xsm:flex-row flex-col">
                            <h3 className="text-blackDark dark:text-textBlackDark font-bold">{t("passenger.stores.browse_products")}</h3>

                            {(!!search || data?.length > 0) && <div className={`border dark:border-[#454545] border-[#D7D8DD] h-[38px] xsm:h-[40px] px-[15px] xlx:px-[17px] flex items-center gap-[8px] xlx:gap-[12px] rounded-full w-full xsm:w-[295px] ${focus ? "dark:bg-bgDarkDull bg-white" : "bg-[#F5F5F5] dark:bg-bgDark dark:hover:bg-bgDarkDull hover:bg-white"}`}>
                                <TableSearch className="xlx:w-[18px] xlx:min-w-[18px] xlx:h-[18px] min-w-[15px] w-[15px] h-[15px] fill-primary" />

                                <input type="text" className="text-opacity-[0.7] text-blackDull dark:text-textBlackDull placeholder:dark:text-textBlackDull font-medium placeholder:text-blackDull placeholder:text-opacity-[0.7] text-sm leading-tight placeholder:leading-tight w-full bg-transparent" placeholder={t("passenger.stores.search_item")} autoComplete="off" value={search} onChange={(e: any) => setSearch(e.target.value)} onFocus={() => setFocus(true)} onBlur={() => setFocus(false)} />
                            </div>}
                        </div>

                        {/* category */}
                        <div className='flex items-center gap-[15px] justify-between'>
                            <div className="flex items-center gap-[10px] overflow-x-auto no-scrollbar scroll-smooth h-[41px] px-[2px]" id="scrollContainer">
                                {categoryLoading ?
                                    <>
                                        {Array.isArray(loaderData) && loaderData?.map((item: any, index: number) => (
                                            <div className="w-[144px] rounded-full bg-gray-200 dark:bg-gray-700 animate-pulse h-[38px]" key={index}></div>
                                        ))}
                                    </>
                                    : <>
                                        {Array.isArray(category) && category?.map((item: any, index: number) => (
                                            <button className={`${select?.id === item?.id ? "border border-[#309657] text-[#309657] bg-white focus:shadow-[0_0_0_2px_#3096575e] hover:shadow-[0_0_0_2px_#3096575e]" : "border border-[#B3B3B3] text-blackDull dark:text-textBlackDull focus:shadow-[0_0_0_2px_#4e566d5e] hover:shadow-[0_0_0_2px_#4e566d5e] dark:focus:shadow-[0_0_0_2px_#ffffff5e] dark:hover:shadow-[0_0_0_2px_#ffffff5e]"} rounded-[20px] flex items-center justify-center h-[35px] xlx:h-[37px] px-[15px] whitespace-nowrap`} key={index} onClick={() => { setSelect(item); setAnimation(true); }}>
                                                <h6 className='font-semibold'>{item?.name}</h6>
                                            </button>
                                        ))}
                                    </>}
                            </div>

                            {!categoryLoading && <div className="flex items-center gap-[8px]">
                                <button aria-label={t("aria_label.prev_arr")}
                                    title={t("aria_label.prev")} className="w-[35px] h-[35px] xlx:h-[39px] xlx:min-w-[39px] flex items-center justify-center rounded-full bg-[#d1d1d133] border border-[#AFAFAF33] focus:shadow-[0_0_0_2px_#3d3d3d5e] hover:shadow-[0_0_0_2px_#3d3d3d5e] dark:bg-opacity-[0.2] dark:bg-[#898989] dark:focus:shadow-[0_0_0_2px_#ffffff5e] dark:hover:shadow-[0_0_0_2px_#ffffff5e] disabled:shadow-none disabled:hover:shadow-none disabled:opacity-[0.5]" onClick={() => handleScroll("left")} disabled={lArr === "block" ? false : true}>
                                    <Prev className="fill-primary !w-[14px] !h-[13px] xlx:!w-[16px] xlx:!h-[15px] dark:fill-[#6294FF]" />
                                </button>
                                <button aria-label={t("aria_label.next_arr")}
                                    title={t("aria_label.next")} className="w-[35px] h-[35px] xlx:h-[39px] xlx:min-w-[39px] flex items-center justify-center rounded-full bg-[#d1d1d133] border border-[#AFAFAF33] focus:shadow-[0_0_0_2px_#3d3d3d5e] hover:shadow-[0_0_0_2px_#3d3d3d5e] dark:bg-opacity-[0.2] dark:bg-[#898989] dark:focus:shadow-[0_0_0_2px_#ffffff5e] dark:hover:shadow-[0_0_0_2px_#ffffff5e] disabled:shadow-none disabled:hover:shadow-none disabled:opacity-[0.5]" onClick={() => handleScroll("right")} disabled={rArr === "block" ? false : true}>
                                    <Next className="fill-primary !w-[14px] !h-[13px] xlx:!w-[16px] xlx:!h-[15px] dark:fill-[#6294FF]" />
                                </button>
                            </div>}
                        </div>
                    </div>

                    <div className="bg-[#F3F3F3] dark:bg-[#454545] h-[5px] min-h-[5px] w-full my-[15px]"></div>

                    {/* products */}
                    <div className="flex flex-col gap-[20px] w-full">
                        {loading ?
                            <div className="flex flex-col gap-[20px] w-full animate-pulse">
                                <div className="w-[120px] h-[12px] bg-gray-200 rounded-full dark:bg-gray-700 my-[5px]"></div>

                                <div className="grid grid-cols-1 xs:grid-cols-2 md:grid-cols-3 mms:grid-cols-4 msm:grid-cols-5 xl:grid-cols-6 gap-[15px] xlx:gap-[20px] w-full">
                                    {Array.isArray(loaderData) && loaderData?.map((item: any, index: number) => (
                                        <div className="flex flex-col w-full" key={index}>
                                            <div className="h-[200px] xs:h-[180px] md:h-[170px] xlx:h-[180px] w-full bg-gray-200 dark:bg-gray-700"></div>

                                            <div className="flex flex-col pt-[10px] gap-[4px]">
                                                <div className="w-[80%] h-[12px] bg-gray-200 rounded-full dark:bg-gray-700"></div>
                                                <div className="w-[60%] h-[12px] bg-gray-200 rounded-full dark:bg-gray-700"></div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                            : <>
                                {isError ?
                                    <div className="h-full w-full my-[-30px] xlx:my-[-60px]">
                                        <Error />
                                    </div>
                                    :
                                    <>
                                        {category?.length > 0 && <>
                                            <div className={`flex flex-col gap-[20px] w-full transition-all duration-75 ${animation && "fadeInUp"}`}>
                                                {Array.isArray(data) && data?.map((item: any, index: number) => (
                                                    <React.Fragment key={index}>
                                                        {select?.name === item?.category && <>
                                                            <h3 className="text-black dark:text-white font-bold">{item?.category}</h3>

                                                            <div className="grid grid-cols-1 xs:grid-cols-2 md:grid-cols-3 mms:grid-cols-4 msm:grid-cols-5 xl:grid-cols-6 gap-[15px] xlx:gap-[20px] w-full">
                                                                {Array.isArray(item?.products) && item?.products.map((i: any, idx: number) => (
                                                                    <div className="flex flex-col w-full" key={idx}>
                                                                        <div className="relative w-full">
                                                                            <div className="absolute top-0 left-0 right-0 bottom-0 bg-[rgba(0,0,0,0.02)] dark:bg-transparent"></div>
                                                                            <img src={i?.image?.file} alt={i?.name} className="h-[200px] xs:h-[180px] md:h-[170px] xlx:h-[180px] w-full" />

                                                                            {!!i?.product_tag && <div className="absolute top-0 left-0 right-0 bottom-0 p-[7px] flex items-start justify-start">
                                                                                <p className="rounded-[3px] bg-[#0E8345] border border-[rgba(0,0,0,0.08)] dark:border-[#454545] flex items-center justify-center px-[5px] h-[20px] text-white font-normal">{i?.product_tag}</p>
                                                                            </div>}

                                                                            <div className="absolute top-0 left-0 right-0 bottom-0 p-[10px] z-[1] flex items-end justify-end">
                                                                                <Link aria-label={t("passenger.stores.cart")} title={t("passenger.stores.cart")} to={i?.product_link} target="_blank" onClick={(e: any) => handleLink(e, i?.product_link)} className="min-w-[38px] w-[38px] h-[38px] rounded-full flex items-center justify-center shadow-[0px_2px_12px_0px_rgba(0,0,0,0.12)] focus:shadow-[0_0_0_2px_#0000005e] hover:shadow-[0_0_0_2px_#0000005e] dark:focus:shadow-[0_0_0_2px_#ffffff5e] dark:hover:shadow-[0_0_0_2px_#ffffff5e] dark:focus:bg-[#5b5a57] dark:hover:bg-[#5b5a57] bg-white dark:bg-bgDarkDull"><AddSvg /></Link>
                                                                            </div>
                                                                        </div>

                                                                        <div className="flex flex-col pt-[10px] gap-[2px]">
                                                                            <h6 className="text-blackDark dark:text-textBlackDark font-medium">{i?.name}</h6>
                                                                            <h6 className="text-primaryText dark:text-white font-semibold flex items-center gap-[6px]">₹{!!i?.discounted_price ? i?.discounted_price : i?.price} <span className="line-through text-gray-500">{!!i?.discounted_price ? `₹${i?.price}` : ""}</span></h6>
                                                                        </div>
                                                                    </div>
                                                                ))}
                                                            </div>
                                                        </>}
                                                    </React.Fragment>
                                                ))}
                                            </div>
                                            <div className={`flex flex-col gap-[20px] w-full transition-all duration-75 ${animation && "fadeInDown"}`}>
                                                {Array.isArray(data) && data?.map((item: any, index: number) => (
                                                    <React.Fragment key={index}>
                                                        {select?.name !== item?.category && <>
                                                            <h3 className="text-black dark:text-white font-bold">{item?.category}</h3>

                                                            <div className="grid grid-cols-1 xs:grid-cols-2 md:grid-cols-3 mms:grid-cols-4 msm:grid-cols-5 xl:grid-cols-6 gap-[15px] xlx:gap-[20px] w-full">
                                                                {Array.isArray(item?.products) && item?.products.map((i: any, idx: number) => (
                                                                    <div className="flex flex-col w-full" key={idx}>
                                                                        <div className="relative w-full">
                                                                            <div className="absolute top-0 left-0 right-0 bottom-0 bg-[rgba(0,0,0,0.02)] dark:bg-transparent"></div>
                                                                            <img src={i?.image?.file} alt={i?.name} className="h-[200px] xs:h-[180px] md:h-[170px] xlx:h-[180px] w-full" />

                                                                            {!!i?.product_tag && <div className="absolute top-0 left-0 right-0 bottom-0 p-[7px] flex items-start justify-start">
                                                                                <p className="rounded-[3px] bg-[#0E8345] border border-[rgba(0,0,0,0.08)] dark:border-[#454545] flex items-center justify-center px-[5px] h-[20px] text-white font-normal">{i?.product_tag}</p>
                                                                            </div>}

                                                                            <div className="absolute top-0 left-0 right-0 bottom-0 p-[10px] z-[1] flex items-end justify-end">
                                                                                <Link aria-label={t("passenger.stores.cart")} title={t("passenger.stores.cart")} to={i?.product_link} target="_blank" className="min-w-[38px] w-[38px] h-[38px] rounded-full flex items-center justify-center shadow-[0px_2px_12px_0px_rgba(0,0,0,0.12)] focus:shadow-[0_0_0_2px_#0000005e] hover:shadow-[0_0_0_2px_#0000005e] dark:focus:shadow-[0_0_0_2px_#ffffff5e] dark:hover:shadow-[0_0_0_2px_#ffffff5e] dark:focus:bg-[#5b5a57] dark:hover:bg-[#5b5a57] bg-white dark:bg-bgDarkDull"><AddSvg /></Link>
                                                                            </div>
                                                                        </div>

                                                                        <div className="flex flex-col pt-[10px] gap-[2px]">
                                                                            <h6 className="text-blackDark dark:text-textBlackDark font-medium">{i?.name}</h6>
                                                                            <h6 className="text-primaryText dark:text-white font-semibold flex items-center gap-[6px]">₹{!!i?.discounted_price ? i?.discounted_price : i?.price} <span className="line-through text-gray-500">{!!i?.discounted_price ? `₹${i?.price}` : ""}</span></h6>
                                                                        </div>
                                                                    </div>
                                                                ))}
                                                            </div>
                                                        </>}
                                                    </React.Fragment>
                                                ))}
                                            </div>
                                        </>}
                                        {((!!!search) && category?.length === 0) &&
                                            <div className="mb-[-50px] xlx:mb-[-60px]">
                                                <EmptyList />
                                            </div>
                                        }

                                        {(!!search && category?.length === 0) &&
                                            <div className="mb-[-70px] xlx:mb-[-120px] mt-[-30px] xlx:mt-[-50px]">
                                                <NoSearch onClick={() => { setSearch("") }} />
                                            </div>
                                        }
                                    </>}
                            </>}
                    </div>
                </div>
            </div >
        </>
    );
};

export default Products;